import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_STRING, StatusLoading } from 'common/constants';

import { IState, STATE } from '../types/state';

import setAllStations from './setAllStations';
import setIsLoadingAllStations from './setIsLoadingAllStations';

import setStations from './setStations';
import setStationsFitBounds from './setStationsFitBounds';
import setIsLoadingStations from './setIsLoadingStations';

import setActionStationsFitBounds from './setActionStationsFitBounds';
import setActionStations from './setActionStations';

import setFilter from './setFilter';
import setFilterStatusLoading from './setFilterStatusLoading';
import setHasActions from './setHasActions';

import setRouteFilter from './setRouteFilter';
import setRestrictions from './setRestrictions';
import {
  DEFAULT_AVAILABILITY,
  DEFAULT_AVAILABILITY_STATUS,
} from 'pages/Map/components/FuelAvailabilityButton/constants';

const initialState: IState = {
  filter: {
    data: {},
  },
  routeFilter: {
    data: {},
  },
  stations: {
    fitBounds: {
      sw: undefined,
      ne: undefined,
    },
    isLoading: StatusLoading.Default,
    data: [],
  },
  actionStations: {
    fitBounds: {
      sw: undefined,
      ne: undefined,
    },
    isLoading: StatusLoading.Default,
    data: [],
  },
  allStations: {
    isLoading: StatusLoading.Load,
    data: [],
    dataMap: {},
  },
  restrictions: {
    serviceNtType: EMPTY_STRING,
    mode: DEFAULT_AVAILABILITY,
    statuses: [DEFAULT_AVAILABILITY_STATUS],
  },
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setIsLoadingAllStations,
    setAllStations,

    setIsLoadingStations,
    setStations,
    setStationsFitBounds,

    setActionStations,
    setActionStationsFitBounds,

    setFilter,
    setFilterStatusLoading,
    setHasActions,

    setRouteFilter,
    setRestrictions,
  },
});

export default slice;
